module.exports = "<router-outlet></router-outlet> <loader ref=\"root\"></loader> \n"